<template>
  <page-layout-full class="ai-chat-view" view="sm">
    <template #title> Тест ИИ-агента на YandexGPT </template>

    <template #subtitle>
      Свой чат поверх Yandex AI Studio: запрос уходит на наш сервер, оттуда — в
      YandexGPT. Ключ Yandex Cloud в браузер не попадает.
    </template>

    <base-loading v-if="isLoading" />

    <template v-else>
      <base-alert v-if="!isConfigured" view="warning">
        Агент не настроен: в админке в настройках модуля «ai» нужно заполнить
        API-ключ сервисного аккаунта Yandex Cloud и идентификатор каталога.
      </base-alert>

      <ai-chat />

      <p class="ai-chat-view__note">
        Агент пока отвечает только на основе общих знаний модели — доступа к
        нашему каталогу, ценам и остаткам у него нет.
      </p>
    </template>
  </page-layout-full>
</template>

<script>
import PageLayoutFull from "@/components/page/PageLayoutFull.vue";
import BaseLoading from "@/components/shared/BaseLoading.vue";
import BaseAlert from "@/components/shared/BaseAlert.vue";
import AiChat from "../components/AiChat.vue";

export default {
  components: {
    PageLayoutFull,
    BaseLoading,
    BaseAlert,
    AiChat,
  },
  data() {
    return {
      isLoading: true,
      isConfigured: false,
    };
  },
  created() {
    this.onFetchStatus();
  },
  methods: {
    onFetchStatus() {
      this.$http
        .get("ai/chat/status")
        .then(({ data }) => {
          this.isConfigured = data.configured;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-view {
  &__note {
    color: $stone;
    font-size: 0.85rem;
    margin-top: 1rem;
  }
}
</style>
